import { controls, grouped } from "../../controls";

const rp202 = {
  label: "Receipts & Payments",
  pageLabel: "Receipts & Payments",
  starting: true,
  url: "rp202",
  pageType: "history",
  form: [],
  filter: [
    ...controls.displayText({ tab: "filter", label: "Parent Branch", width: "col-sm-2" }),
    ...controls.branch({ tab: "filter", isReadOnly: true, defaultValue: "assigned_branch", width: "col-sm-2" }),
    ...controls.showData({ tab: "filter", data: "branch_display", name: "branch_display", }),


    ...controls.displayText({ label: "Region", width: "col-sm-3", tag: "basic" }),
    ...controls.Region({ tag: "basic", width: "col-sm-3" }),
    {
      inputType: "showdata",
      tab: "Modal",
      data: "region",
      textcolor: "black",
      name: "region_display",
      widths: {
        parent: "col-sm-5",
        children: "col-sm-12"
      }, tag: "basic"
    },

    ...controls.displayText({ tab: "filter", label: "Print Receipts/Payment", width: "col-sm-3", tag: "basic" }),
    {
      inputType: "select",
      default: "",
      widths: {
        parent: "col-sm-7",
        children: "col-sm-12"
      },
      options: [
        {
          label: "Total",
          value: "Total"
        },
        {
          label: "Cash Transfer Clearing Seperate",
          value: "Cash Transfer Clearing Seperate"
        },
        {
          label: "Cash And Other",
          value: "Cash And Other"
        },
        {
          label: "Transfer And Other",
          value: "Transfer And Other"
        }, {
          label: "Clearing And Other",
          value: "Clearing And Other"
        }, {
          label: "Cash and Other(receipt) and Total Payment",
          value: "Cash and Other(receipt) and Total Payment"
        }, {
          label: "Total Receipt and Cash and Other Payment",
          value: "Total Receipt and Cash and Other Payment"
        }, {
          label: "Transfer and Other(receipt) and Total Payment",
          value: "Transfer and Other(receipt) and Total Payment"
        }, {
          label: "Total Receipt and Transfer and Other Payment",
          value: "Total Receipt and Transfer and Other Payment"
        }, {
          label: "Clearing and Other(receipt) and Total Payment",
          value: "Clearing and Other(receipt) and Total Payment"
        }, {
          label: "Total Receipt and Clearing and Other Payment",
          value: "Total Receipt and Clearing and Other Payment"
        },
      ],
      placeHolder: "Print Receipt/Payment",
      name: "Print Receipt_Payment",
      description: "Enter Receipt/Payment", tag: "basic"
    },
    ...controls.displayText({ tab: "filter", width: "col-sm-2", tag: "basic" }),
    ...controls.hr({ tab: 'filter', width: "col-sm-12", label: " ", style: { marginBottom: 10 }, tag: "basic" }),

    ...grouped.separation('basic'),
    ...grouped.grouping('basic'),




    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "filter", label: "With Branch", name: "isPrintBranch", width: "col-sm-2" }),

    ...controls.displayText({ tab: 'filter', label: "Product Group" }),
    ...controls.ProductGroup({ tab: 'filter' }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),
    ...controls.checkBox({ tab: "filter", label: "With Member Name", name: "isPrintMember", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Product Type", width: "col-sm-2" }),
    ...controls.ProductType({
      tab: "filter",
    }),
    ...controls.showData({ tab: "filter", data: "product_type_display", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "filter", label: "With Member Type", name: "isPrintMemberType", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "GL Sub Head", width: "col-sm-2" }),
    ...controls.product({ tab: "filter", }),
    ...controls.showData({ tab: "filter", data: "product_code_display", width: "col-sm-2" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),
    ...controls.checkBox({ tab: "filter", label: "With Address", name: "isPrintAddress", width: "col-sm-2" }),

    ...controls.displayText({ tab: "filter", label: "Transaction Type", width: "col-sm-2" }),
    ...controls.TransactionType({ tab: 'filter' }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "Receipts / Payments", width: "col-sm-2" }),
    ...controls.ReceiptPayments({ tab: 'filter', width: "col-sm-4" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-6" }),


    ...controls.displayText({ tab: "filter", label: "Balance / Interest", width: "col-sm-2" }),
    ...controls.BalanceInterest({ tab: "filter", width: "col-sm-3" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-7" }),

    ...controls.displayText({ tab: "filter", label: "Member Type", width: "col-sm-2" }),
    ...controls.MemberType({ tab: 'filter' }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8" }),

    ...controls.displayText({ tab: "filter", label: "With Rec/Payment?", width: "col-sm-2" }),
    ...controls.PrintReceiptPayments({ tab: 'filter' }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-8" }),


    ...controls.displayText({ tab: "filter", label: "Ac No From", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Ac No From", name: "account_number_from" }),
    ...controls.displayText({ tab: "filter", label: "Ac No To", width: "col-sm-2" }),
    ...controls.text({ placeHolder: "Ac No To", name: "account_number_to" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "With Account Type", name: "isPrintAcType", width: "col-sm-2" }),

    ...controls.magicDateLabel({ tab: "filter", label: "Ac Opening From", width: "col-sm-2" }),
    ...controls.magicDate({ name: "ac_open_date_from" }),
    ...controls.magicDateLabel({ tab: "filter", label: "To Date", width: "col-sm-2" }),
    ...controls.magicDate({ name: "ac_open_date_to" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-2" }),
    ...controls.checkBox({ tab: "filter", label: "Staff Only", name: "isStaffOnly", width: "col-sm-2" }),


    ...controls.magicDateLabel({ tab: "filter", label: "Transaction From", width: "col-sm-2" }),
    ...controls.magicDate({ name: "trn_date_from", default: "sessiondate" }),
    ...controls.magicDateLabel({ tab: "filter", label: "Transaction To Date", width: "col-sm-2" }),
    ...controls.magicDate({ name: "trn_date_to", default: "sessiondate" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),


    ...controls.displayText({ tab: "filter", label: "Amount From", width: "col-sm-2" }),
    ...controls.floatOnly({ name: "amount_from" }),
    ...controls.displayText({ tab: "filter", label: "Amount To", width: "col-sm-2" }),
    ...controls.floatOnly({ name: "amount_to" }),
    ...controls.displayText({ tab: "filter", label: "", width: "col-sm-4" }),
  ],
  history: {
    perPage: 10,
    reportHeader: "Deposit Accounts",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    clickable: true,
    displayColumns: [
      {
        Header: "Branch",
        accessor: "branch_code",
        width: 150
      },
      {
        Header: "A/C No",
        accessor: "account_number",
        width: 150
      },
      {
        Header: "CIN",
        accessor: "cin",
      },
      {
        Header: "Name",
        accessor: "description"
      },
      {
        Header: "Opening",
        accessor: "opening_balance",
        type: "currency",
      },

      {
        Header: "Receipts",
        columns: [
          {
            Header: "Transfer",
            accessor: "transfer_receipts",
            type: "currency",
          },
          {
            Header: "Cash",
            accessor: "cash_receipts",
            type: "currency",
          },
          {
            Header: "Clearing",
            accessor: "clearing_receipts",
            type: "currency",
          },
          {
            Header: "Total",
            accessor: "total_receipts",
            type: "currency",
            formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'fixed', field: 'transfer_receipts' }, { source: 'fixed', field: 'cash_receipts' }, { source: 'fixed', field: 'clearing_receipts' }], resultVar: 'total' }],
          },
        ]
      },
      {
        Header: "Payments",
        columns: [
          {
            Header: "Transfer",
            accessor: "transfer_receipts",
            type: "currency",
          },
          {
            Header: "Cash",
            accessor: "cash_receipts",
            type: "currency",
          },
          {
            Header: "Clearing",
            accessor: "clearing_receipts",
            type: "currency",
          },
          {
            Header: "Total",
            accessor: "total_receipts",
            type: "currency",
            formula: [{ f: 'simpleArithmatic', calcType: 'sum', inputs: [{ source: 'fixed', field: 'transfer_receipts' }, { source: 'fixed', field: 'cash_receipts' }, { source: 'fixed', field: 'clearing_receipts' }], resultVar: 'total' }],
          },
        ]
      },


      {
        Header: "Date",
        accessor: "trndate",
      },

      {
        Header: "Risk Cat",
        accessor: "risk_cat",
      },
      {
        Header: "PAN",
        accessor: "pan",
      },
      {
        Header: "AADHAAR",
        accessor: "aadhaar",
      },
      {
        Header: "KYC",
        accessor: "kyc",
        type: 'tick'
      },
      {
        Header: "DOB",
        accessor: "dob",
      },
      {
        Header: "Acct Type",
        accessor: "account_type",
      },
      {
        Header: "Mobile",
        accessor: "mobile",
      },
      {
        Header: "Address",
        accessor: "address1",
      },
      {
        Header: "Member Type",
        accessor: "member_type",
      },
      {
        Header: "Interest Type",
        accessor: "interest_type",
      },
    ]
  }
}
export default rp202;